import { Pencil, Trash2 } from "lucide-react";
import { RiskBadge } from "../../components/ui";

export default function ThresholdsTable({ thresholds, onEdit, onDelete }) {
  return (
    <div className="space-y-1">
      {/* Header */}
      <div className="flex items-center px-3 py-2 text-xs font-medium text-gray-500">
        <div className="w-24">Risk Level</div>
        <div className="w-20 text-center">Score</div>
        <div className="flex-1" />
      </div>

      {/* Thresholds List */}
      <div className="space-y-0.5">
        {thresholds.map((t) => (
          <div
            key={t.id}
            className="group flex items-center px-3 py-2 bg-white hover:bg-gray-50 border border-gray-100 rounded-md"
          >
            {/* Risk Level Badge */}
            <div className="w-24">
              <RiskBadge level={t.label} />
            </div>

            {/* Score Range */}
            <div className="w-20 text-center">
              <span className="text-xs font-medium text-gray-700">
                {t.min_score} - {t.max_score}
              </span>
            </div>

            {/* Actions */}
            <div className="flex-1 flex justify-end gap-1">
              <ActionButton
                icon={<Pencil size={13} />}
                onClick={() => onEdit(t)}
                title="Edit"
                color="blue"
              />
              <ActionButton
                icon={<Trash2 size={13} />}
                onClick={() => onDelete(t.id)}
                title="Delete"
                color="red"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// Helper Components
function ActionButton({ icon, onClick, title, color }) {
  const getColor = () => {
    return color === 'red' 
      ? 'hover:text-red-500 hover:bg-red-50'
      : 'hover:text-blue-500 hover:bg-blue-50';
  };

  return (
    <button
      onClick={onClick}
      className={`p-1 text-gray-400 rounded-md transition-colors ${getColor()}`}
      title={title}
    >
      {icon}
    </button>
  );
}